import React, { useEffect, useState } from "react";
const START_SECONDS = 17 * 60 + 34;
export function Countdown() {
  const [seconds, setSeconds] = useState(START_SECONDS);
  useEffect(() => {
    const id = window.setInterval(() => {
      setSeconds(s => s <= 1 ? START_SECONDS : s - 1);
    }, 1000);
    return () => window.clearInterval(id);
  }, []);
  const parts = [{
    label: "Hours",
    value: Math.floor(seconds / 3600)
  }, {
    label: "Min",
    value: Math.floor(seconds % 3600 / 60)
  }, {
    label: "Sec",
    value: seconds % 60
  }];
  return <div className="w-full" role="timer" aria-live="off" data-id="element-95" data-mp="3h2a8n2874yrc">
      <p className="text-center text-sm font-bold text-red-600" data-id="element-96" data-mp="324hw8ixy4qhd">This promotional price ends in:</p>
      <div className="mt-2 flex items-center justify-center gap-2" data-id="element-97" data-mp="371zvfhm5vrc6">
        {parts.map((p, i) => <React.Fragment key={p.label} data-id="element-98" data-mp="10c3hfsqp8256" data-mpi={i}>
            <div className="flex w-[4.5rem] flex-col items-center rounded-xl bg-navy-950 py-2 text-white" data-id="element-99" data-mp="10d4v84z3n2ql">
              <span className="font-mono text-3xl font-black tabular-nums" data-id="element-100" data-mp="159bxnnsadw3s">{String(p.value).padStart(2, "0")}</span>
              <span className="text-[11px] font-semibold text-navy-300" data-id="element-101" data-mp="t23djiym9nfk">{p.label}</span>
            </div>
            {i < parts.length - 1 && <span className="text-2xl font-black text-navy-950" data-id="element-102" data-mp="17r9dxa96xjp1">:</span>}
          </React.Fragment>)}
      </div>
    </div>;
}